<template lang='pug'>
  .auth-header.component
    bf-wrapper.max-760.container
      img.drawer-toggle(
        src='/ui/menu.png'
        :class='{ open: open.left }'
        @click.stop='open_left'
      )

      left-nav(:class='{ open: open.left }')
        static-links

        bf-divider.mini

        bf-link.combo(
          v-if='$route.name != "sign-up"'
          :to='{ name: "sign-up" }'
        )
          template(v-slot:icon)
            sign-in-icon
          template(v-slot:text) {{ $t('Sign Up') }}

        bf-link.combo(
          v-if='$route.name != "sign-in"'
          :to='{ name: "sign-in" }'
        )
          template(v-slot:icon)
            sign-in-icon
          template(v-slot:text) {{ $t('Sign In') }}

    bf-flex.centered.logo-container
      router-link.logo.link.container( :to='{ path: "/" }' )
        .beta-tag(v-if="1==0") BETA
        img(src='/logo.png')

    bf-translate

    bf-wrapper.centered
      table.top
        tr
          td
            span {{ $t("Your") }} 
            span.top1 {{ $t("Local Marketplace") }}
        tr  
          td
            span {{ $t("for") }} 
            span.top1 {{ $t("Buy/Sell") }} 
            span {{ $t("and") }} 
            span.top1 {{$t("Services")}}
      

    //- .links
    //-   bf-wrapper.content
    //-     bf-flex
    //-       router-link.sign-up.link( :to='{ name: "sign-in" }' ) {{ $t('Sign In') }}
    //-       router-link.sign-in.link( :to='{ name: "sign-up", params: {id: $route.params.id} }' ) {{ $t('Sign Up') }}

    // .shape
</template>

<script>
  import LeftNav from '@/components/left-nav'
  import StaticLinks from '@/components/static-links'

  export default {
    name: 'auth-header.component',

    components: {
      LeftNav,
      StaticLinks
    },

    props: {
      open: Object
    },

    data() {
      return {
        // open: { left: false }
      }
    },

    methods: {
      open_left() {
        this.$emit('open')
        this.open.left = true
      }
    }
  }
</script>
<style scoped lang='stylus'>
  // @media( min-width: 1080px )
  //   .drawer-toggle, .link.close, .bf-divider.close
  //     display none !important
  .bf-wrapper.centered
    max-width 530px
    @media(max-width: 640px)
      max-width 360px

  .left-nav
    top 65px

  .top
    color white
    font-size 40px
    @media(max-width: 640px)
      font-size 25px
    .top1 
      padding 5px
      font-family roboto
      
  .auth-header
    background rgba(32 69 141 .8)
    padding-bottom 80px
    position relative
    .bf-link
      font-size 1.2em
      padding 8px 16px
      text-align left
      margin 0
      width 100%
      box-sizing border-box
      display flex
      justify-content flex-start
    //   &.toggle:hover
    //     background 0
    //     transform scale(1)
    //   &:first-child
    //     border-top 0
    //   &:last-child
    //     border-bottom 0
    // .router-link-active
    //   color auto
    //   filter drop-shadow( 0 0 4px rgba(255 255 255 .5) )

  .drawer-toggle
    margin-right auto
    position absolute
    height 26px
    width 30px
    z-index 1
    right 10px
    // top 16px
    padding 12px

  .logo
    display block
    margin-top 40px
    @media(max-width: 640px)
      margin-top 10px

    .beta-tag
      background var(--clr-light)
      font-weight bold
      padding 1px 3px .5px 3px
      top -4px
      color var(--bg-nav)
      position absolute
      right 0
      border-radius 3px
      line-height 1
      font-family monospace
      font-size 1.36em
    img
      width 220px

  .links
    justify-content space-between
    color rgba( 255 255 255 .75 )
    font-size 1.5em
    padding 4px 64px
    letter-spacing .5px
    .content .bf-flex
      justify-content space-between

  .router-link-active
    color white
    font-weight bold

  .shape
    height 0
    width 0
    position absolute
    bottom -1px
    border-left 50vw solid transparent
    border-right 50vw solid transparent
    border-bottom 48px solid rgba(255 255 255 .5)
    @media( min-width: 1080px )
      display none
</style>
